import axios from "axios";
import {createUrlParams} from "../../utils/urlParams";


export const getIncidents = async (filters) => {
    const urlParams = createUrlParams(filters)
    const url = `/api/v1/public/timeseries/incidents?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}
